import * as React from "react";
// Components
import { BaseComponent } from "../../BaseComponent";
import { DatePicker as FabricDatePicker } from "@fluentui/react";
// Constants
import { calendarNavigationIcons } from "../calendar/Calendar";
// Styles
import { getDatePickerStyles, getTextFieldStyles } from "./DatePicker.styles";
import { getCalendarStyles, getCalendarDayStyles, getCalendarMonthStyles } from "../calendar/Calendar.styles";
import { calendarIconProps } from "../../../icons/icons.styles";
// Utilities
import { css } from "@fluentui/utilities/lib/css";
/**
 * DatePicker control that customizes the fabric control to our own purposes
 */ export class DatePicker extends BaseComponent {
    /**
     * Name of the component
     */ name() {
        return "DatePicker";
    }
    /**
     * Render the DatePicker based on passed props
     */ renderComponent() {
        // Inject our custom classname
        const { children, ...passThroughProps } = {
            ...this.props,
            styles: getDatePickerStyles(this.props.appTheme),
            calendarProps: {
                styles: getCalendarStyles(this.props.appTheme),
                calendarDayProps: {
                    styles: getCalendarDayStyles(this.props.appTheme),
                    navigationIcons: calendarNavigationIcons
                },
                calendarMonthProps: {
                    styles: getCalendarMonthStyles(this.props.appTheme),
                    navigationIcons: calendarNavigationIcons
                }
            },
            calloutProps: {
                ...this.props.calloutProps,
                className: css("plannerAppCallout", this.props.calloutProps?.className)
            },
            textField: {
                ...this.props.textField,
                iconProps: {
                    ...this.props.textField?.iconProps,
                    ...calendarIconProps,
                    "aria-hidden": !!this.props.disabled,
                    role: "button"
                },
                styles: getTextFieldStyles(this.props.appTheme, this.props.disabled)
            }
        };
        return /*#__PURE__*/ React.createElement(FabricDatePicker, passThroughProps, children);
    }
    /**
     * Initialize a new instance of the DatePicker
     * @param props Props for the component
     * @param [context] Context or initial state for the base component.
     */ constructor(props, context){
        super(props, context);
    }
}
